import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import ComingSoonIcon from './ComingSoonIcon'

const useStyles = makeStyles(theme => ({
  root: props => ({
    alignItems: 'center',
    height: '100%',
    padding: 15,
    position: 'relative'
  }),
  titleContainer: {
    height: '20%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataContainer: {
    flex: 1,
    maxWidth: 350,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  }
}))

const ComingSoon = ({ title }) => {
  const classes = useStyles()

  return (
    <Grid container direction="column" className={classes.root}>
      <Grid item style={{ height: '20%' }} className={classes.titleContainer}>
        <DazzedHeadingForGrid regular xs={14} sm={14} md={14} lg={16} xl={16}>
          {title}
        </DazzedHeadingForGrid>
      </Grid>
      <Grid item style={{ height: '80%', display: 'flex' }} className={classes.dataContainer}>
        <ComingSoonIcon />
      </Grid>
    </Grid>
  )
}

export default ComingSoon
